import { call, put, select, type Effect } from 'redux-saga/effects';
import { getShouldRefetchBacklogOnClose } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/update-jira/index.tsx';
import { setRefetchBacklogOnClose } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/top/title-bar/update-jira/actions.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { getBacklog } from '../../backlog/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* doHandleCloseDialog(): Generator<Effect, void, any> {
	const shouldRefetchBacklog = yield select(getShouldRefetchBacklogOnClose);

	if (!expVal('unblock_plans_save_changes', 'isEnabled', false)) return;

	if (shouldRefetchBacklog) {
		yield put(setRefetchBacklogOnClose(false));
		yield call(getBacklog);
	}
}
